// extracted by mini-css-extract-plugin
module.exports = {"head":"e_eN","heading":"e_fN","headLink":"e_gN","intro":"e_hN"};